<template>
  <div class="faq-mgt-page">
    <div class="global-header-wrap">
      <span v-if="!$route.query.id">{{ $t("commonMsg.new") }}</span>
      <span v-else>{{ $t("commonMsg.edit") }}</span>
      <div>
        <button class="global-button-style" @click="$router.back()">
          {{ $t("commonMsg.back") }}
        </button>
        <button class="global-button-style" @click="submitForm('ruleForm')">
          {{ $t("commonMsg.save") }}
        </button>
        <!-- <button class="global-button-style" @click="toPublic('ruleForm')">
          {{ $t("commonMsg.release") }}
        </button> -->
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap">
        <el-form
          label-width="120px"
          :model="faq"
          @submit.native.prevent
          ref="ruleForm"
          :rules="rules"
        >
          <el-form-item :label="$t('update.category')">
            <!-- <el-input
              v-model="faq.category"
              class="fl"
              style="width: 200px"
            ></el-input> -->
            <p>{{ $route.query.categoryName }}</p>
          </el-form-item>
          <el-form-item :label="$t('update.title')" prop="title">
            <el-input
              v-model="faq.title"
              class="fl"
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item :label="$t('boox.region')" prop="region">
            <el-radio-group v-model="faq.region">
              <el-radio label="1">国内</el-radio>
              <el-radio label="2">国外</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <el-form-item label="型号(用\隔开)" prop="model">
            <el-input v-model="faq.model"></el-input>
          </el-form-item>
          <el-form-item label="设备型号组" prop="modelGroups">
            <el-checkbox-group v-model="faq.modelGroups">
              <el-checkbox
                v-for="item in modelData"
                :key="item._id"
                :label="item._id"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <!-- <el-form-item label="语言(用\隔开)" prop="lang">
            <el-input v-model="faq.lang"></el-input>
          </el-form-item>
          <el-form-item label="语言组" prop="langGroups">
            <el-checkbox-group v-model="faq.langGroups">
              <el-checkbox
                v-for="item in langData"
                :key="item._id"
                :label="item._id"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item> -->
          <el-form-item :label="$t('update.introduce')">
            <editor
              api-key="j9xdmm7yklb7mhgzd47u5biiqnnx621qcgm9vta30ejwd4ow"
              v-model="faq.description"
              :init="{
                height: 500,
                menubar: true,
                language: 'zh_CN',
                font_formats:
                  '微软雅黑=Microsoft YaHei;黑体=STHeiti;宋体=simsun;仿宋=STFangsong;新宋体=NSimSun;楷体=KaiTi;隶书=LiSu;幼圆=YouYuan;行楷=STXingkai;姚体=FZYaoti;新魏=STXinwei',
                plugins: [
                  'advlist autolink lists link image charmap print preview anchor',
                  'searchreplace visualblocks code fullscreen',
                  'insertdatetime media table paste code help wordcount',
                ],
                file_picker_types: 'image media',
                file_picker_callback: handleUpload,
                toolbar:
                  'undo redo | formatselect | bold italic underline forecolor backcolor fontsizeselect | \
                               alignleft aligncenter alignright alignjustify | \
                               bullist numlist outdent indent | \
                               image media | link unlink | table removeformat',
              }"
            />
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import OSS from "ali-oss";
import Editor from "@tinymce/tinymce-vue";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["buckets"]),
  },
  components: {
    editor: Editor,
  },
  data() {
    return {
      modelData: [],
      langData: [],
      faq: {
        model: "",
        modelGroups: [],
        // lang: "",
        // langGroups: [],
        category: this.$route.query.categoryId,
        title: "",
        description: "",
      },
      isSave: false,
      rules: {
        category: [
          {
            required: true,
            message: this.$t("update.inputTitle"),
            trigger: "blur",
          },
        ],
        title: [
          {
            required: true,
            message: this.$t("update.inputTitle"),
            trigger: "blur",
          },
        ],
      },
      resimg: "",
      resVideo: "",
    };
  },
  methods: {
    handleUpload(callback, value, meta) {
      if (meta.filetype == "media") {
        // 上传视频
        //创建一个隐藏的type=file的文件选择input
        let input = document.createElement("input"); //创建一个隐藏的input
        input.setAttribute("type", "file");
        input.onchange = async (e) => {
          let file = e.target.files[0]; //选取第一个文件
          await this.uploadFile(file, "media"); // 上传视频拿到url
          callback(this.resVideo);
        };
        //触发点击
        input.click();
      } else if (meta.filetype == "image") {
        // 上传图片
        let input = document.createElement("input"); //创建一个隐藏的input
        input.setAttribute("type", "file");
        input.onchange = async (e) => {
          let file = e.target.files[0]; //选取第一个文件
          await this.uploadFile(file, "image"); // 上传视频拿到url
          callback(this.resimg);
        };
        //触发点击
        input.click();
      }
    },
    async uploadFile(file, type) {
      let { bucket } = this.buckets["onyx-static"];
      let fileObj = await this.uploadOss(file, bucket, "neocloud_admin");

      if (type == "image") {
        this.resimg = fileObj.url;
      } else if (type == "media") {
        this.resVideo = fileObj.url;
      }
    },

    getModelGroups() {
      this.$http.getModelGroups().then((res) => {
        this.modelData = res.data.results;
      });
    },
    getLangGroups() {
      this.$http.getLangGroups().then((res) => {
        this.langData = res.data.results;
      });
    },

    getAppDetails() {
      this.$http.getFaqDetails(this.$route.query.id).then((res) => {
        res.data.model = res.data.model.join("\\");
        // res.data.lang = res.data.lang.join("\\");
        this.faq = Object.assign({}, res.data);
      });
    },

    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.$route.query.id) {
            this.edit();
          } else {
            this.create();
          }
        } else {
          return false;
        }
      });
    },

    // toPublic(formName) {
    //   this.$refs[formName].validate(async valid => {
    //     if (valid) {
    //       if (this.$route.query.id) {
    //         this.faq.public = 1;
    //         this.edit();
    //       } else {
    //         this.faq.public = 1;
    //         this.create();
    //       }
    //     } else {
    //       return false;
    //     }
    //   });
    // },

    async create() {
      let body = Object.assign({}, this.faq);
      body.model = this.faq.model.split("\\");
      // body.lang = this.faq.lang.split("\\");
      this.$http.createFaq(body).then((res) => {
        this.elMsg(this.$t("alertMsg.addSuccess"), "success");
        this.$router.back();
      });
    },

    // async publicFaq() {
    //   this.$http.publicFaq(this.faq).then(res => {
    //     this.elMsg(this.$t("alertMsg.publicSuccess"), "success");
    //     this.$router.back();
    //   });
    // },

    async edit() {
      this.$http.putFaq(this.$route.query.id, this.faq).then((res) => {
        this.elMsg(this.$t("alertMsg.editSuccess"), "success");
        this.$router.back();
      });
    },

    uploadOss(file, bucket, key) {
      return new Promise(async (resolve, reject) => {
        try {
          let sts = await this.$http.aliyunSts();
          let { region } = this.buckets["onyx-static"];
          let client = await new OSS({
            region,
            accessKeyId: sts.data.AccessKeyId,
            accessKeySecret: sts.data.AccessKeySecret,
            stsToken: sts.data.SecurityToken,
            bucket,
            secure: true,
          });
          let coverData = await client.multipartUpload(
            `${key}/${file.name}`,
            file,
            {
              progress: (p, cpt, res) => {
                this.progress = Number((p * 100).toFixed(2));
              },
            }
          );

          resolve({
            key: coverData.name,
            bucket,
            name: file.name,
            url: coverData.res.requestUrls[0].split("?")[0],
          });
        } catch (error) {
          reject(error);
        }
      });
    },

    random_string(len) {
      len = len || 32;
      var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      var maxPos = chars.length;
      var pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
  },
  mounted() {
    this.getModelGroups();
    // this.getLangGroups();
    if (!this.$route.query.id) return;
    this.getAppDetails();
  },
};
</script>

<style lang="scss">
.faq-mgt-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    .el-form {
      width: 80%;
      margin: 10px auto;
      .global-button-style {
        width: 100%;
        margin: 0;
      }
      .faq-import-btn {
        margin-top: 10px;
      }
      .faq-upload-progress {
        display: flex;
        align-items: center;
        > .el-progress__text {
          /* width: 100px; */
        }
      }
    }
  }
}
.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label,
.el-form-item--small .el-form-item__content {
  /* line-height: 24px; */
}
.ql-editor {
  height: 450px;
}
</style>
